/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type LambdaMigrationStateEnum = 'NOT_STARTED' | 'IN_PROGRESS' | 'FAILED' | 'COMPLETED' | 'NOT_APPLICABLE';

export const LambdaMigrationStateEnum = {

    NOT_STARTED: 'NOT_STARTED' as LambdaMigrationStateEnum,

    IN_PROGRESS: 'IN_PROGRESS' as LambdaMigrationStateEnum,

    FAILED: 'FAILED' as LambdaMigrationStateEnum,

    COMPLETED: 'COMPLETED' as LambdaMigrationStateEnum,

    NOT_APPLICABLE: 'NOT_APPLICABLE' as LambdaMigrationStateEnum
};

